import gql from "graphql-tag";

// Fresh profile for the logged-in user. Selects role name + organization type
// (the shared userFields fragment only has role.organization { id }) plus the
// full contact-method set and default organization.
export const ACCOUNT_USER = gql`
  query AccountUser($id: ID!) {
    user(id: $id) {
      id
      username
      firstName
      lastName
      twoFactorMethod
      skipTwoFactorUntil
      contactMethods {
        id
        type
        value
        isDefault
        isActive
      }
      roles {
        role {
          name
          bypassTwoFactor
        }
        organization {
          id
          name
          type
        }
      }
      defaultOrganization {
        id
        name
        type
      }
    }
  }
`;

// Re-export the shared full-profile update (name + contact methods) so the
// account page has one import for its mutations.
export { updateUser as UPDATE_USER } from "../../graphql/users";

// Authenticated 2FA change (My Account): send an OTP to the selected contact
// method. Returns a short-lived token to pass back on confirmation.
export const SEND_TWO_FACTOR_OTP = gql`
  mutation SendTwoFactorOtp($contactMethodId: String!) {
    sendTwoFactorOtp(contactMethodId: $contactMethodId) {
      token
      contactMethod {
        id
        type
        contact
      }
      message
    }
  }
`;

// Authenticated 2FA change (My Account): verify the OTP and apply the new
// method. Returns the updated user (no new session — the user stays signed in).
export const CONFIRM_TWO_FACTOR_CHANGE = gql`
  mutation ConfirmTwoFactorChange($token: String!, $otp: String!) {
    confirmTwoFactorChange(token: $token, otp: $otp) {
      id
      twoFactorMethod
      skipTwoFactorUntil
    }
  }
`;
